import { post } from "../../../shared/data";

export const searchSLA = (params, source) => {
    const sourcePage = source ? `?sourcePage=${source}` : "";

    return post(`/sla/list/search${sourcePage}`, params);
};
